<template>
  <div
    class="approval-comments-and-btns"
  >
    <!-- BI图表 -->
    <div v-if="dashboardUrl" ref="iframeWrapper" style="height: 400px;">
      <iframe
        ref="dashboardIframe"
        :src="dashboardUrl"
        frameborder="0"
        allowtransparency
        width="100%"
        height="100%"
      />
    </div>
    <div style="border: 1px solid #E3E3E3; margin-left: 10px; margin-right: 10px; margin-top: 10px;">
      <div style="margin: 5px">
        <el-tabs v-model="activeName">
          <el-tab-pane v-if="isApprove" :label="$t('CargoMsg.Cargo_ApprovalComments')" name="comments">
            <process-content :form="form" />
          </el-tab-pane>
          <el-tab-pane :label="$t('CargoMsg.Cargo_ApprovalCommentsRecord')" name="record">
            <div style="max-height: 130px; overflow: auto">
              <div v-for="(record, index) in records" :key="index">
                <el-card class="box-card">
                  <div v-if="record.actionType !== 7000" style="display: flex">
                    <span>{{ $t('CargoMsg.Cargo_Approver') }}： </span>
                    <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                    <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalComments') }}： </span>
                    <span>{{ WorkflowUtil.getActionName(record.actionType) }}</span>
                    <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                    <span>{{ record.remark }}</span>
                    <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalTime') }}： </span>
                    <span>{{ record.createTime }}</span>
                  </div>
                  <div v-else style="display: flex">
                    <span>{{ $t('CargoMsg.Cargo_Initiator') }}： </span>
                    <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                    <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                    <span>{{ record.remark }}</span>
                    <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_StartTime') }}： </span>
                    <span>{{ record.createTime }}</span>
                  </div>
                  <div v-show="record.files && record.files.length > 0" style="margin-top: 10px;cursor: pointer;">
                    <div v-for="(file, index) in record.files" :key="index" style="display: inline-block;" class="file-style">
                      <div style="margin-left: 10px; display: flex" @click="downloadFile(file.fileId)">
                        <i class="el-icon-paperclip" />
                        <span class="file-name">{{ file.fileName }}</span>
                        <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="default" name="default" />
        </el-tabs>
      </div>
    </div>
    <div v-if="isApply && hasBtn" style="margin-top: 10px; margin-bottom: 10px">
      <span style="margin-left: 10px">{{ $t('CargoMsg.Cargo_Remarks') }}:</span>
      <process-content :form="form" />
    </div>
    <div style="display: flex; margin-top: 10px; margin-left: 10px">
      {{ $t('CargoMsg.Cargo_RefuseAndReturnNode') }}
    </div>
    <div style="margin-top: 10px; margin-right: 10px">
      <el-button v-for="(btn, index) in btnList" :key="index" :title="btn.title" :type="btn.color" @click="onAction(btn)">{{ btn.actionName }}</el-button>
      <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <!-- 加签 人员配置 -->
    <choose-user-dialog-add
      v-if="chooseUserDialogAdd.visible"
      :title="$t('CargoMsg.Cargo_SelectSigner')"
      :visible.sync="chooseUserDialogAdd.visible"
      :value="chooseUserDialogAdd.userIds"
      @close="chooseUserDialogAdd.visible=false"
      @change="addSignature"
    />
    <!-- 转签 人员配置 -->
    <choose-user-dialog-transfer
      v-if="chooseUserDialogTransfer.visible"
      :title="$t('CargoMsg.Cargo_SelectTransferor')"
      :visible.sync="chooseUserDialogTransfer.visible"
      :value="chooseUserDialogTransfer.userIds"
      @close="chooseUserDialogTransfer.visible=false"
      @change="transferSignature"
    />
  </div>
</template>
<script>

import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getAddSignatureInfo, workflowAction, workflowCheck } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ProcessContent from '@/components/Cargo/Common/Wrokflow/processContent'
import { deleteFile, uploadStorage } from '@/api/storage'
import { cache, cacheName } from '@/utils/cacheManager'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChooseUserDialogAdd from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseUserDialogTransfer from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import URL from '@/api/urlTranslator'

export default {
  name: 'BillPaymentWorkFlowApplyDialog',
  components: { ProcessContent, cargoAdvanceSelect, BillPaymentDialog, ChooseUserDialogAdd, ChooseUserDialogTransfer },
  props: {
    processInfo: { type: Object, default: () => {} }, // 审核流程
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    records: { type: Array, default: () => [] }, // 审核记录
    formSubtype: { type: Number, default: () => 0 },
    dashboardUrl: { type: String, default: () => '' },
    applicationDimension: { type: Number, default: () => 0 }
  },
  data() {
    return {
      loading: null,
      form: {
        fileList: [],
        remark: ''
      },
      btnList: [],
      ColumnUtils: ColumnUtils,
      WorkflowUtil: WorkflowUtil,
      TYPE_NAMES: TYPE_NAMES,
      showBillPaymentDialog: false,
      activeName: 'comments',
      approvalRemark: '',
      storageURL: '',
      workflowName: '',
      oldBillPayment: {},
      receiveTypes: ClearingConstants.AMOUNT_RECEIVE_TYPES, // 收付方式源
      skipApprove: true, // 跳过审核，为了达到刚进来是不显示弹窗的效果，默认值为true；在check之后，若不跳过审核 或 未匹配到审批流，都将该值赋false，即不跳过审核，即显示审批弹窗
      chooseUserDialogAdd: {
        visible: false,
        userIds: []
      },
      chooseUserDialogTransfer: {
        visible: false,
        userId: null
      },
      btn: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hasBtn() {
      return this.btnList && this.btnList.length > 0
    },
    isApply() {
      return this.type === 'apply'
    },
    isApprove() {
      return this.type === 'approve' && this.hasBtn
    }
  },
  watch: {
  },
  async created() {
    if (this.type !== 'look' || (this.processInfo && this.processInfo.state === 0)) {
      await this.init()
    }
    this.activeName = !this.isApprove ? 'record' : 'comments'
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      const params = {
        documentConfigId: this.processInfo.documentConfigId,
        docId: this.processInfo.docId,
        officeId: this.processInfo.officeId,
        documentProcessId: this.processInfo.documentProcessId,
        applicationDimension: this.processInfo.applicationDimension,
        formSubtype: this.formSubtype
      }
      await workflowCheck(params).then(res => {
        if (res.data && res.data.actions && res.data.actions.length > 0) {
          const btns = res.data.actions
          for (const btn of btns) {
            btn.color = btn.actionType > 7001 && [7008, 7011, 7012, 7013, 7014].indexOf(btn.actionType) === -1 ? 'danger' : 'primary'
            btn.title = btn.actionType === 7002 ? this.$t('CargoMsg.Cargo_RefuseTitle') : btn.actionType === 7006 ? this.$t('CargoMsg.Cargo_ReturnTitle') : ''
          }
          this.documentProcessId = res.data.documentProcessId
          this.workflowName = res.data.workflowName
          this.btnList = btns
        }
      }).catch(reason => {
      })
    },
    // 按钮动作
    onAction(btn) {
      this.btn = btn
      // 【加签动作】
      if (btn.actionType === 7011) {
        getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
          if (res.data.userIds && res.data.userIds.length > 0) {
            this.chooseUserDialogAdd.userIds = res.data.userIds
          }
          this.chooseUserDialogAdd.visible = true
        })
        return
      }
      // 【转签动作】
      if (btn.actionType === 7012) {
        this.chooseUserDialogTransfer.visible = true
        return
      }
      this.doAction(btn)
    },
    doAction(btn) {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [btn.actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.loading = getLoading()
        await this.upload()
        const params = {
          documentConfigId: this.processInfo.documentConfigId,
          docId: this.processInfo.docId,
          actionId: btn.id,
          remark: this.form.remark,
          fileList: this.form.fileList,
          actionType: btn.actionType,
          officeId: this.processInfo.officeId,
          documentProcessId: this.processInfo.documentProcessId,
          applicationDimension: this.processInfo.applicationDimension,
          signatureUserId: this.chooseUserDialogAdd.userIds && this.chooseUserDialogAdd.userIds.length > 0 ? this.chooseUserDialogAdd.userIds.join(',') : this.chooseUserDialogTransfer.userId,
          nodeId: !this.processInfo ? null : this.processInfo.nodeId
        }
        workflowAction(params).then(res => {
          this.$message.success(btn.actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          this.$emit('closeAndRefresh')
        }).catch(reason => {
          // 操作失败 且存在附件的情况下，删除附件
          this.removeFile()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    addSignature(userIds) {
      getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
        // 不允许对自己‘取消加签’
        if (res.data.userIds && res.data.userIds.length > 0) {
          if (res.data.userIds.indexOf(this.$store.getters.userId) !== -1 && userIds.indexOf(this.$store.getters.userId) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignature'))
            return
          }
        }
        // 不允许对自己‘加签’
        if ((!res.data.userIds || res.data.userIds.indexOf(this.$store.getters.userId) === -1) && userIds.indexOf(this.$store.getters.userId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureSelf'))
          return
        }
        // 不允许对‘已审批’或‘已委派’的人‘取消加签’
        if (res.data.fixUserIds && res.data.fixUserIds.length > 0) {
          for (const userId of res.data.fixUserIds) {
            if (userIds.indexOf(userId) === -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignatureNotSupport'))
              return
            }
          }
        }
        // 会签下，不允许对当前节点人加签
        if (res.data.disableAddSignatureUserIds && res.data.disableAddSignatureUserIds.length > 0) {
          for (const userId of userIds) {
            if (res.data.disableAddSignatureUserIds.indexOf(userId) !== -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureCurrentNode'))
              return
            }
          }
        }
        this.chooseUserDialogAdd.visible = true
        this.chooseUserDialogAdd.userIds = userIds
        this.doAction(this.btn)
      })
    },
    transferSignature(userIds) {
      if (!userIds || userIds.length === 0) {
        return
      }
      // 只允许选择一个人‘转签人’
      if (userIds.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      // 不允许选择自己作为‘转签人’
      if (userIds[0] === this.$store.getters.userId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TransferSignatureSelf'))
        return
      }
      this.chooseUserDialogTransfer.visible = true
      this.chooseUserDialogTransfer.userId = userIds[0]
      this.doAction(this.btn)
    },
    handleClose() {
      this.$emit('close')
    },
    // 上传附件
    async upload() {
      const rows = this.form.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p
            params.documentType = 'workflow'
            return uploadStorage(params).then(res => {
              p.fileId = res.data
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          `上传成功:${uploadSuccessCount}个,上传失败:${uploadFailCount}个.`,
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      }
    },
    // 动作提交失败，则删除附件
    removeFile() {
      const rows = this.form.fileList.filter(p => p.fileId)
      if (rows.length === 0) {
        return
      }
      Promise.all(
        Array.from(rows, p => {
          return deleteFile(p.fileId).then(res => {
          })
        })
      )
    },
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
.approval-comments-and-btns {
  border-top: 1px solid #e3e3e3;
  .el-tabs.el-tabs--top .el-tabs__content{
    margin-top: 15px;
  }
  .el-upload-dragger{
    margin-top: 10px;
    height: 40px;
    width: 130px;
    .el-icon-upload{
      margin: 15px 10px 16px !important;
      display: inline-block;
      font-size: 24px;
      line-height: 50px;
    }
  }
  .drop-uploader-icon{
    height: 100%; display: flex; align-items: center; justify-content: center;
  }
  #tab-record.el-tabs__item.is-top.is-active {
    color: #1f75d5;
    background-color: transparent;
  }
  #tab-comments.el-tabs__item.is-top.is-active {
    color: #1f75d5;
    background-color: transparent;
  }
  #tab-record.el-tabs__item.is-top {
    color: black;
    background-color: transparent;
  }
  #tab-comments.el-tabs__item.is-top {
    color: black;
    background-color: transparent;
  }
  .el-tabs__nav-scroll {
    background-color: #FFFFFF;
  }
  .el-tabs__nav-wrap.is-top::after {
    left: 7px
  }
  #tab-default.el-tabs__item {
    display: none;
  }
}
</style>

